import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { withStyles } from '@mui/styles';
import { Link, useHistory } from 'react-router-dom';
import AssignmentListItem from '../AssignmentListItem/AssignmentListItem';
import AssignmentListEmptyState from '../AssignmentListItem/AssignmentListEmptyState';
import { COLORS } from '../../../utils/Application_Constants';
import { isAssignmentVisible } from '../../../utils/assignmentVisibilityHelpers';

const styles = () => ({
    header: {
        color: COLORS.WATERLOO,
        fontWeight: '700',
        fontSize: '18px',
        textAlign: 'left',
    },
    upcomingAssignmentHeading: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginLeft: '-20px',
    },
    upcomingAssignmentHeadingLevel2: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '40px',
    },
    clickableSpan: {
        fontWeight: '500',
        color: COLORS.TRUE_BLUE,
        fontSize: '16px',
        cursor: 'pointer',
        borderBottom: `1px dashed ${COLORS.TRUE_BLUE}`,
    },
});

const UpcomingAssignmentDashboard = ({ assignments, classes }) => {
    const { ltoeWebAssignmentsPreBooking } = useFlags();
    const history = useHistory();

    const filteredAssignments = assignments
        ? assignments.filter((assignment) =>
              isAssignmentVisible(assignment, ltoeWebAssignmentsPreBooking)
          )
        : [];

    const toggleAssignmentView = (assignment) => {
        history.push(`/assignments/upcoming/${assignment.id}`);
    };

    const renderAssignmentsConditionally = () => {
        const assignmentCount = filteredAssignments.length;
        if (assignmentCount === 0) {
            return <AssignmentListEmptyState assignmentType="upcoming" />;
        }
        if (assignmentCount === 1) {
            return (
                <AssignmentListItem
                    type="upcoming"
                    toggleAssignmentView={() => toggleAssignmentView(filteredAssignments[0])}
                    assignment={filteredAssignments[0]}
                />
            );
        }
        if (assignmentCount >= 2) {
            return (
                <>
                    <AssignmentListItem
                        type="upcoming"
                        toggleAssignmentView={() => toggleAssignmentView(filteredAssignments[0])}
                        assignment={filteredAssignments[0]}
                    />

                    <AssignmentListItem
                        type="upcoming"
                        toggleAssignmentView={() => toggleAssignmentView(filteredAssignments[1])}
                        assignment={filteredAssignments[1]}
                    />
                </>
            );
        }
    };

    const renderAssignmentTitleConditonally = () => {
        if (filteredAssignments.length === 0) {
            return (
                <span className="tileHeader">
                    Upcoming Assignments({filteredAssignments.length})
                </span>
            );
        }

        return (
            <div className={classes.upcomingAssignmentHeadingLevel2}>
                <span className="tileHeader">
                    Upcoming Assignments({filteredAssignments.length})
                </span>
                <Link
                    to="/assignments/upcoming"
                    className="textLink"
                    style={{ marginBottom: '.5rem' }}
                >
                    View All
                </Link>
            </div>
        );
    };

    return (
        <>
            {renderAssignmentTitleConditonally()}
            {renderAssignmentsConditionally()}
        </>
    );
};

export default withStyles(styles)(UpcomingAssignmentDashboard);
